import { getIsApiPending, getQuoteForm, getQuote } from '../../../selectors/afyaImara/quote';
import {
    apiTransitionAfyaImaraInsuranceQuoteForm,
    calculateAfyaImaraInsurancePremiumSuccess,
} from '../../../actions/afyaImara/quote';
import { getAccessToken } from '../../../selectors/afyaImara/payments';
import axios from 'axios';

// sample payload

// {
//     "countryCode": "KE",
//     "productId": 1,
//     "age": 53,
//     "inPatient": {
//         "inpatientLimitId": 1
//     },
//     "outPatient": {
//         "present": true,
//         "outpatientLimitId": 1,
//         "option": 1
//     },
//     "familyMembers": {
//         "children": {
//             "count": 2
//         },
//         "spouse": {
//             "age": 53
//         }
//     }
// }

export const premiumCalculationService = (store, next, action) => {
    (async () => {
        if (!getIsApiPending(store.getState())) {
            store.dispatch(apiTransitionAfyaImaraInsuranceQuoteForm.pending());
            try {
                const resp = await calculate(store.getState());
                store.dispatch(calculateAfyaImaraInsurancePremiumSuccess(resp.data));
                store.dispatch(apiTransitionAfyaImaraInsuranceQuoteForm.success());
            } catch (e) {
                console.error(e);
                store.dispatch(apiTransitionAfyaImaraInsuranceQuoteForm.failure());
            }
        }
    })();
    return next(action);
};

function getAgeFromDateString(dateString) {
    // Split the date string into day, month, and year components
    if (!dateString || dateString == null) {
        return null;
    }
    const [day, month, year] = dateString.split('/').map(Number);

    // Create a Date object for the date of birth
    const birthDate = new Date(year, month - 1, day); // Month is 0-indexed in JavaScript Date

    // Get the current date
    const today = new Date();

    // Calculate the age
    let age = today.getFullYear() - birthDate.getFullYear();

    // Adjust age if the current date is before the birthdate in the current year
    const currentMonth = today.getMonth();
    const birthMonth = birthDate.getMonth();
    if (currentMonth < birthMonth || (currentMonth === birthMonth && today.getDate() < birthDate.getDate())) {
        age--;
    }

    return age;
}

const premiumCalculationPayload = (state) => {
    const quote = getQuote(state);
    const quotation = getQuoteForm(state);
    const premiumCalculationPayload = {
        countryCode: 'KE',
        fullName: quotation?.fullName?.value || '',
        email: quotation?.email?.value || '',
        phoneNumber: quotation?.phoneNumber?.value || '',
        productId: quote?.productId || null,
        age: getAgeFromDateString(quotation?.dob?.value) || 0,
        inPatient: {
            inpatientLimitId: quotation?.inpatientCover?.value,
        },
        outPatient: {
            present: quotation?.outpatientCover?.value ? true : false,
            outpatientLimitId: quotation?.outpatientCover?.value,
            option:
                quote?.productId === '2' || quote.productId === '3' || quote?.productId === '6'
                    ? 2
                    : quotation?.outpatientCoverOption?.value !== 'per family per annum'
                    ? 2
                    : 1,
        },
        familyMembers: {
            children: {
                count: quotation?.childrenDobs?.value?.length || 0,
            },
            spouse: {
                age: parseInt(quotation?.spouseDob?.value) || 0,
            },
        },
        omRescuePlus: quotation?.omRescuePlus?.value,
    };

    // Change payload here
    return {
        ...premiumCalculationPayload,
    };
};

const calculate = async (state) => {
    const loginData = getAccessToken(state);
    try {
        const url = '/om-api/ke-afya-imara/compute-premium';
        return await axios.post(url, premiumCalculationPayload(state), {
            headers: {
                'Content-Type': 'application/json',
                accessToken: loginData.accessToken,
            },
        });
    } catch (e) {
        console.error(e);
        throw e;
    }
};
